import React from "react";
import { useNavigate } from "react-router-dom";
import heroImage from "../../assets/Hero1.jpg";
import heroBot from "../../assets/herobot.jpeg";

function Hero() {
  const navigate = useNavigate();

  const handleLogin = () => {
    navigate("/login"); // Change path if your route is different
  };
  return (
    <div className="relative h-screen w-full overflow-hidden">
      {/* Background Layer */}
      <div
        className="absolute inset-0 bg-cover bg-center filter blur-sm brightness-50"
        style={{ backgroundImage: `url(${heroImage})` }}
      ></div>

      {/* Foreground Content */}
      <div className="relative z-10 flex flex-col md:flex-row items-center justify-between h-full px-6 md:px-16 text-white">
        
        {/* Text Content */}
        <div className="w-full md:w-2/3 space-y-6 pt-20 md:pt-0 mt-32 md:mt-10 ">
          <h1 className="text-4xl md:text-6xl font-extrabold leading-tight tracking-tight mb-20 md:mb-10">
            <span className="bg-gradient-to-r from-cyan-400 via-gray-100 to-cyan-400 bg-clip-text text-transparent animate-pulse md:text-7xl text- ">Master the Markets.</span>
            <br />
          
            <span className="bg-gradient-to-r from-gray-100 via-cyan-400 to-gray-100 bg-clip-text text-transparent text-3xl md:text-6xl">Trade Smarter with AI.</span>
          </h1>

          <p className="text-lg md:text-2xl text-neutral-300 max-w-2xl">
            Unlock your trading potential with our all-in-one{" "}
            <span className="text-cyan-400 font-semibold">
              Forex & Binary platform
            </span>
            . Get expert-guided trading tools, AI-powered bots, and a premium
            marketplace — designed to help you profit faster, safer, and smarter.
          </p>

          <div className="pt-8 md:pt-4 inline-flex">
            <button
              onClick={() => {
                const section = document.getElementById("about");
                if (section) {
                  section.scrollIntoView({ behavior: "smooth" });
                }
              }}
              className="bg-cyan-700 hover:bg-cyan-800 text-white font-bold py-3 px-6 rounded-2xl transition duration-300 shadow-lg"
            >
              Get Started
            </button>
            <button
              onClick={handleLogin}
              className="bg-green-700 hover:bg-green-800 text-white font-bold py-3 px-6 rounded-2xl transition duration-300 shadow-lg ml-10"
            >
              Login/Signup
            </button>
          </div>
        </div>

        {/* Image Section - hidden on small screens */}
        <div className="hidden md:flex md:w-1/3 justify-center items-center pt-10 md:pt-0">
          <img
            src={heroBot}
            alt="Trading Bot"
            className="w-64 h-64 md:w-72 md:h-72 object-cover rounded-full border-4 border-cyan-500 shadow-lg brightness-75 animate-spin-slow"
          />
        </div>
      </div>
    </div>
  );
}

export default Hero;
